import { menuConstants } from '~/components/sitecore/bedroom-search-form/menuConfig.ts'

const {
  LOCATION_MENU,
  DATES_MENU,
  GUESTS_MENU,
  BOOKING_FOR_MENU
} = menuConstants

const bedroomsFormMixin = {
  data () {
    return {
      visibleMenu: ''
    }
  },

  computed: {
    isLocationMenuOpen () {
      return this.visibleMenu === LOCATION_MENU
    },

    isDatesMenuOpen () {
      return this.visibleMenu === DATES_MENU
    },

    isGuestsMenuOpen () {
      return this.visibleMenu === GUESTS_MENU
    },

    isBookingForMenuOpen () {
      return this.visibleMenu === BOOKING_FOR_MENU
    }

  },

  methods: {
    dismissMenu () {
      this.visibleMenu = ''
    },

    handleToggleMenu (menu) {
      this.visibleMenu = menu !== this.visibleMenu ? menu : ''
    },

    handleToggleLocationMenu () {
      return this.handleToggleMenu(LOCATION_MENU)
    },

    handleToggleDatesMenu () {
      return this.handleToggleMenu(DATES_MENU)
    },

    handleToggleGuestsMenu () {
      return this.handleToggleMenu(GUESTS_MENU)
    },

    handleToggleBookingForMenu () {
      return this.handleToggleMenu(BOOKING_FOR_MENU)
    }
  }
}

export default bedroomsFormMixin
